import * as tslib_1 from "tslib";
import React, { PureComponent } from 'react';
import Container from './Container';
import Content from './Content';
import { Theme } from '../theme';
var Lozenge = /** @class */ (function (_super) {
    tslib_1.__extends(Lozenge, _super);
    function Lozenge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lozenge.prototype.render = function () {
        var _a = this.props, theme = _a.theme, children = _a.children;
        return (React.createElement(Theme.Provider, { value: theme },
            React.createElement(Theme.Consumer, tslib_1.__assign({}, this.props), function (tokens) { return (React.createElement(Container, tslib_1.__assign({}, tokens),
                React.createElement(Content, tslib_1.__assign({}, tokens), children))); })));
    };
    Lozenge.defaultProps = {
        isBold: false,
        appearance: 'default',
        maxWidth: 200,
    };
    return Lozenge;
}(PureComponent));
export default Lozenge;
//# sourceMappingURL=index.js.map